import { initializeMsal, loginRedirect, logout, onAuthStateChange } from '../auth/auth.js';
import { renderAuthUI } from '../auth/renderAuthUI';
import { pushLoginStatus, startLoginStatusTimeout } from '../auth/loginStatus';

/**
 * Wires the MyHU session (Azure B2C via MSAL, see ../auth) to the header
 * widgets and to the GTM data layer.
 *
 * Must run synchronously while the bundle executes, not on `ready`: when the
 * server rendered no MSAL config, auth.js notifies "logged out" on its first
 * microtask, and the listener has to be registered before that. The
 * `login_status` deadline is armed between the two for the same reason — GTM
 * fires GA4's page_view on that event, so it has to arrive even if MSAL never
 * answers (see ../auth/loginStatus.js).
 */
export function initMyHuLogin() {
    renderAuthUI({ isAuthenticated: false, account: null, inProgress: true });
    onAuthStateChange((state) => {
        renderAuthUI(state);
        pushLoginStatus(state);
    });
    startLoginStatusTimeout();

    initializeMsal();

    const loginBtn = document.getElementById('login-btn');
    const logoutBtn = document.getElementById('logout-btn');
    const loginBtnMobile = document.getElementById('login-btn-mobile');

    if (loginBtn) {
        loginBtn.addEventListener('click', () => loginRedirect());
    }
    if (logoutBtn) {
        logoutBtn.addEventListener('click', () => logout());
    }
    // There is no logout button in `myhu-profile-container-mobile` (see
    // partial/_nav.antlers.html): the desktop `#logout-btn` is the only one.
    if (loginBtnMobile) {
        loginBtnMobile.addEventListener('click', () => loginRedirect());
    }
}
